<template>
  <span v-if="!isUserCustomer">
    <div v-for="(label, key) in labels" :key="key" style="display: inline-block;margin-right: 20px">
      <div :style="'display: inline-block; width: 30px; height: 10px; background-color:' + label.bgColor">
        <i :class="label.icon"></i>
      </div>
      <div class="ml-1" style="display: inline-block; font-size: 9pt">
        {{label.label}}
      </div>
    </div>
  </span>
</template>

<script>
export default {
  beforeMount() {
    if (this.isUserRoot || this.isUserPlatformEmployee) {
      this.labels.unshift(
          {
            label: 'Pending / Should Create Rates',
            bgColor: '#5f4dee',
            icon: ''
          }
      )
    }
  },
  data () {
    return {
      isUserCustomer: $store.getters['user-state/isUserCustomer'],
      isUserRoot: $store.getters['user-state/isUserRoot'],
      isUserPlatformEmployee: $store.getters['user-state/isUserPlatformEmployee'],
      labels: [
        {
          label: 'Working',
          bgColor: '#11ca8a',
          icon: ''
        },
        {
          label: 'Awaiting Action',
          bgColor: '#11a8ca',
          icon: ''
        },
        {
          label: 'Require Test',
          bgColor: '#a79f9f',
          icon: ''
        },
        {
          label: 'FAS ',
          bgColor: '#FFC300',
          icon: ''
        },
        {
          label: 'Unconnected',
          bgColor: '#ca2d11',
          icon: ''
        },
        {
          label: 'View Test',
          bgColor: 'transparent',
          icon: 'el-icon-view'
        },
      ]
    }
  }
}
</script>
